import React from 'react'
import { Tonality } from '@dsny/dsny-component-library'
import { Close } from '@dsny/dsny-component-library/icons'

const FilterPill = ({
  option,
  filterType,
  isSelected,
  onToggle,
  disabled = false
}) => {
  const handleClick = () => {
    if (!disabled) {
      onToggle?.(null, option.name, option.id)
    }
  }

  const handleIconClick = (e) => {
    e.stopPropagation()
    if (!disabled) {
      onToggle(null, option.name, option.id)
    }
  }

  return (
    <Tonality.Pill
      variant="tonal"
      label={option.name}
      mode="dark"
      key={option.id}
      selected={isSelected}
      disabled={disabled}
      onClick={handleClick}
      icon={isSelected ? <Close width={16} height={16} /> : null}
      iconPosition="tailing"
      onIconClick={handleIconClick}
    />
  )
}

export default FilterPill
